export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numero"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nome"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azioni"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifica le informazioni sul raccoglitore"])}
}